import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../lib/cn.ts'

export const badgeVariants = cva(
  cn(
    'inline-flex items-center justify-center gap-1 rounded-md font-semibold whitespace-nowrap leading-none',
    'border border-transparent',
  ),
  {
    variants: {
      tone: {
        default: 'bg-background-secondary text-foreground border-border',
        muted: 'bg-transparent text-muted border-border/60',
        primary: 'bg-primary-light text-primary border-transparent',
        success: 'bg-toast-success text-toast-success-text',
        warning: 'bg-toast-warning text-toast-warning-text',
        danger: 'bg-toast-error text-toast-error-text',
        info: 'bg-toast-info text-toast-info-text',
      },
      size: {
        sm: 'px-1.5 py-0.5 text-[10px] uppercase tracking-wide',
        md: 'px-2 py-0.5 text-xs',
      },
    },
    defaultVariants: { tone: 'default', size: 'md' },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
